import { createFileRoute } from "@tanstack/react-router";
import { SubmissionSettingsPage } from "~/pages/SubmissionSettingsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/submissions")({
  component: SubmissionSettingsPage,
});
